import React, { createContext } from 'react'
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import { useAppCtx } from './app-ctx';

import Stars from './Stars';
import Slideshow from './slide-show';
import ImageMatrix from './image-matrix';
import ResortFeaturesList from './resort-feaure-list';
import RoomTypes from './resort-room-types';



/**
 * 
        $resortModel->resort_id = $resortData->resort_id;
        $resortModel->name = $resortData->name;
        $resortModel->stars = $resortData->stars;
        $resortModel->address = $resortData->address;
        $resortModel->treatment_from = $resortData->treatment_from;
        $resortModel->city_id = $resortData->city_id;
        $resortModel->city_name = $resortData->city_name;
        $resortModel->region_id = $resortData->region_id;
        $resortModel->region_name = $resortData->region_name;
        $resortModel->attrs = $resortData->attrs;

        $resortModel->rooms = $resortData->rooms;
        $resortModel->descriptionsRaw = $resortData->descriptions;

            $resortModel->description = $desc->description;
            $resortModel->descriptionRooms = $desc->description;
            $resortModel->descriptionBoardings = $desc->description;
            $resortModel->descriptionServices = $desc->description;
            $resortModel->descriptionAdditionalServices = $desc->description;
            $resortModel->descriptionTreatmentServices = $desc->description;
            $resortModel->descriptionCancellationPolicy = $desc->description;
            
        $resortModel->imagesRaw = [ { // all images
                            resort_id;
                            relation,
                            filename,
                            path,
                            mime 
                    },
                    ....
        ]
        $resortModel->images = [ {  // all images except main (one with 'relation' == 0)
                resort_id;
                relation,
                filename,
                path,
                mime 
            },
            ...
        ]
        $resortModel->mainImage = {
            resort_id;
            relation
            filename 
            path
            mime ;
        }
 * */


const ResortDetailsFull = ({theResort, moreImagesClick}) => {
    const { t } = useTranslation();
    const {searchCriterias} = useAppCtx();

    const handeMoreImagesClick = (evt) => {
        if (moreImagesClick)
            moreImagesClick(evt);
    }

    //console.log('ResortDetails(): Entry: theResort=', JSON.stringify(theResort));
    console.log('ResortDetails(): Entry: searchCriterias=', JSON.stringify(searchCriterias));

    const handleToBookOnClick = () => {
        console.log('ResortDetails.handleToBookOnClick()');
    }

    return (
        <div className='main-description'>
            <div className='main-image-wrapper'>
                <Slideshow images={theResort.imageUrlsAll} autoPlay={true} interval={3000} transition="slide" 
                    showArrows={false} showDots={false} showButton={false} />
            </div>

            <div className='address-description-rooms-wrapper'>
                <h1><span>{theResort.name}</span>
                    <Stars rating={theResort.stars} maxStars={5}/></h1>
                <address>{theResort.address}</address>
                <h6 className='topic'><img src={theResort.icons['description']} alt="description" className="topic-icon " />
                    <span>{t('Description')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.description }} />
            </div>

            <div className='image-matrix-wrapper'>
                <div>
                    <h6 className='topic'><img src={theResort.icons['features']} alt="features" className="topic-icon " />
                        <span>{t('Features')}</span></h6>
                    <ResortFeaturesList features={theResort.features} />
                </div>

                <ImageMatrix images={theResort.imageUrlsAll} autoChange={true} />
                <div>
                    <button className='more-images-button' onClick={handeMoreImagesClick}>
                        {t('More Images')}
                    </button>
                </div>
            </div>
            
            <div className='descriptions-wrapper'>
                <h6 className='topic'><img src={theResort.icons['rooms']} alt="rooms" className="topic-icon " />
                    <span>{t('Room Types Available')}</span></h6>
                <RoomTypes resortId={theResort.resort_id} 
                    roomsData={theResort.rooms} 
                    occupacyValue={searchCriterias.occupacyValue} 
                    dietaryValue={searchCriterias.dietaryValue} 
                    dateRangeValue={searchCriterias.dateRangeValue} />
                <div className="book-button-container">
                    <a className="book-button button is-primary" onClick={handleToBookOnClick} 
                        href={theResort.toBookUrl}>{t("Book Now")}</a>
                </div>

                <h6 className='topic'><span><img src={theResort.icons['rooms']} alt="rooms" className="topic-icon " />
                    </span><span>{t('Rooms')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionRooms }} />
                <h6 className='topic'><img src={theResort.icons['services']} alt="services" className="topic-icon " />
                    <span>{t('Services')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionServices }} />
                <h6 className='topic'><img src={theResort.icons['additional_services']} alt="additionalServices" className="topic-icon " />
                    <span>{t('Additional services')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionAdditionalServices }} />
                <h6 className='topic'><img src={theResort.icons['treatment']} alt="treatment" className="topic-icon " />
                    <span>{t('Treatment')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionTreatmentServices }} />
                <h6 className='topic'><img src={theResort.icons['boardings']} alt="boardings" className="topic-icon " />
                    <span>{t('Boardings')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionBoardings }} />
                <ul className='boardings-list'>{theResort.boardings.map(board => (
                        <li className='board-item' key={board.board_id}>{board.description}</li>
                    ))}
                </ul>
                <h6 className='topic'><img src={theResort.icons['cancellation_policy']} alt="cancellationPolicy" className="topic-icon " />
                    <span>{t('Cancellation policy')}</span></h6>
                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionCancellationPolicy }} />
            </div>
        </div>
    );
}

export default ResortDetailsFull;